import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";
import Label from "../Label";
import Section from "../Section";
import "./MessageBox.scss";

interface Props {
  type: "error" | "success";
  title: string;
  content?: string;
}

const icons = {
  error: faExclamationCircle,
  success: faCheckCircle
};

const MessageBox: React.FC<Props> = ({ type, title, content }) => {
  return (
    <Section className={`message-box ${type}`} fluid={true}>
      <div className="message-box-container">
        <div className="message-box--icon">
          <FontAwesomeIcon icon={icons[type]} />
        </div>
        <div className="message-box--content">
          <Label labelName={title} tagName="h3" />
          {content && <Label labelName={content} tagName="p" />}
        </div>
      </div>
    </Section>
  );
};

export default MessageBox;
